import type Insured from '@/modules/common/common/models/APP/Insured'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

import PetsSavePolicyHolderRequest from '@/modules/pets/hiring/models/MID/requests/PetsSavePolicyHolderRequest'

export default class SavePolicyHolderMapper {
  static toRequest(quotationId: string, holder: Insured): PetsSavePolicyHolderRequest {
    const dataProtection = {
      dataTransfer: holder.dataTransfer,
      thirdPartyTelephoneAdvertising: holder.thirdPartyTelephoneAdvertising,
      thirdPartyWrittenAdvertising: holder.thirdPartyWrittenAdvertising
    }

    return new PetsSavePolicyHolderRequest({
      quotationId,
      policyHolder: {
        name: holder.userDetails.name?.toUpperCase(),
        firstSurname: holder.userDetails.surname1?.toUpperCase(),
        secondSurname: holder.userDetails.surname2?.toUpperCase(),
        birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate),
        sex: holder.userDetails.gender,
        street: holder.addressDetails.address,
        city: holder.addressDetails.city,
        house: holder.addressDetails.roadNumber,
        postalCode: holder.addressDetails.postalCode,
        province: holder.addressDetails.province,
        houseType: holder.addressDetails.houseType,
        gateway: holder.addressDetails.gateway,
        stair: holder.addressDetails.stair,
        floor: holder.addressDetails.floor,
        doorway: holder.addressDetails.doorway,
        restAddres: holder.addressDetails.addressExtra,
        addressNormalice: holder.addressDetails.addressNormalize,
        streetType: holder.addressDetails.streetType || 'CALLE',
        email: holder.userDetails.email,
        prefix: holder.userDetails.prefix,
        mobilePhone: holder.userDetails.phone
      },
      dataProtection: !holder.thirdPartiesAnswered ? dataProtection : undefined
    })
  }
}
